import { ChangeEventHandler, FunctionComponent } from 'react';
import GenericIcons from './generics/GenericIcons';
import '../css/AppHome.css';

export type SelectDataType = { value: string | number; name: string | number };

const SelectInput: FunctionComponent<{
  label: string;
  name: string;
  id: string;
  value: string;
  onChange: ChangeEventHandler<HTMLSelectElement>;
  options: Array<SelectDataType>;
  icon?: string;
  disabled?: boolean;
}> = ({ label, name, id, value, onChange, options, icon, disabled }) => {
  return (
    <div className='select-input-container'>
      {icon && <GenericIcons icon={icon} className='select-input-right-icon' />}

      <select
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        className={`select-input ${icon ? 'select-input-padding-left' : ''}`}
        disabled={disabled}>
        <option value='' disabled>
          {label}
        </option>
        {options.map((row, idx) => (
          <option key={idx} value={row.value}>
            {row.name}
          </option>
        ))}
      </select>
      <GenericIcons icon='chevronDownIcon' className='select-input-arrow-icon' />
    </div>
  );
};

export default SelectInput;
